import { render, staticRenderFns } from "./MspForsageOrdersItem.vue?vue&type=template&id=2f451e39&"
import script from "./MspForsageOrdersItem.vue?vue&type=script&lang=js&"
export * from "./MspForsageOrdersItem.vue?vue&type=script&lang=js&"
import style0 from "./MspForsageOrdersItem.vue?vue&type=style&index=0&id=2f451e39&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports